import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import React, { useEffect, useRef, useState } from 'react';

type LottieAnimationData = object;

export default function LottieAnimation({
  data,
}: {
  data: LottieAnimationData;
}) {
  const lottieRef = useRef<LottieRefCurrentProps | null>(null);
  const [animationFinished, setAnimationFinished] = useState(false);

  useEffect(() => {
    if (lottieRef?.current) {
      lottieRef?.current.setSpeed(1.8);
    }
  }, []);

  return (
    <>
      {' '}
      {!animationFinished && (
        <div className='w-full h-[100px] top-0 absolute md:w-[400px] mx-auto'>
          <Lottie
            lottieRef={lottieRef}
            height={200}
            loop={false}
            animationData={data}
            onComplete={() => setAnimationFinished(true)}
          />
        </div>
      )}
    </>
  );
}
